if (!customElements.get('tj-recipe-carousel')) {
  customElements.define(
    'tj-recipe-carousel',
    class RecipeCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.track = this.querySelector('[data-recipe-track]');
        this.previousButton = this.querySelector('[data-recipe-previous]');
        this.nextButton = this.querySelector('[data-recipe-next]');
        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.initialized = true;
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onScroll = () => this.updateControls();

        this.previousButton.addEventListener('click', this.onPrevious);
        this.nextButton.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateControls());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.onScroll);
        }

        requestAnimationFrame(() => this.updateControls());
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.onScroll);
      }

      move(direction) {
        const card = this.track.querySelector('.tj-featured-recipe');
        if (!card) return;

        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.track.scrollBy({
          left: direction * distance,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      updateControls() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft >= maxScroll - 2;

        this.previousButton.disabled = atStart;
        this.nextButton.disabled = atEnd;
        this.classList.toggle('is-static', maxScroll <= 2);
      }
    }
  );
}
